// extracted by mini-css-extract-plugin
export default {"container":"RecommendationsCard_container__MfX9V","title":"RecommendationsCard_title__LA5oM","recommendations":"RecommendationsCard_recommendations__p5U7y"};